import {
    DescriptionEntry,
    NumberFieldEntry,
    TextFieldEntry,
} from "@bpmn-io/properties-panel";
import { useService } from "bpmn-js-properties-panel";

export default function RulePropertiesProvider(props) {
    const { idPrefix, parameter } = props;

    const entries = [
        {
            id: idPrefix + "-name",
            component: Name,
            idPrefix,
            parameter,
        },
        {
            id: idPrefix + "-process",
            component: Process,
            idPrefix,
            parameter,
        },
        {
            forId: idPrefix + "-process",
            value: "A process (Task, Gateway, Event) name or process id.",
            component: RuleDescription,
        },
        {
            id: idPrefix + "-condition",
            component: Condition,
            idPrefix,
            parameter,
        },
        {
            forId: idPrefix + "-condition",
            value: "One ore many comma seperated rule conditions.",
            component: RuleDescription,
        },
        {
            id: idPrefix + "-priority",
            component: Priority,
            idPrefix,
            parameter,
        },
    ];

    return entries;
}

function Name(props) {
    const { idPrefix, element, parameter } = props;

    const commandStack = useService("commandStack");
    const translate = useService("translate");
    const debounce = useService("debounceInput");

    const setValue = (value) => {
        commandStack.execute("element.updateModdleProperties", {
            element,
            moddleElement: parameter,
            properties: {
                name: value,
            },
        });
    };

    const getValue = (parameter) => {
        return parameter.name;
    };

    return TextFieldEntry({
        element: parameter,
        id: idPrefix + "-name",
        label: `*${translate("Name")}`,
        getValue,
        setValue,
        debounce,
    });
}

function RuleDescription(props) {
    const { element, forId, value } = props;

    const entry = (
        <DescriptionEntry
            element={element}
            forId={forId}
            value=<div style="margin-left:12px; margin-right:30px">{value}</div>
        />
    );

    return entry;
}

function Process(props) {
    const { idPrefix, element, parameter } = props;

    const commandStack = useService("commandStack");
    const translate = useService("translate");
    const debounce = useService("debounceInput");

    const setValue = (value) => {
        commandStack.execute("element.updateModdleProperties", {
            element,
            moddleElement: parameter,
            properties: {
                process: value,
            },
        });
    };

    const getValue = (parameter) => {
        return parameter.process;
    };

    return TextFieldEntry({
        element: parameter,
        id: idPrefix + "-process",
        label: `*${translate("Process")}`,
        getValue,
        setValue,
        debounce,
    });
}

function Condition(props) {
    const { idPrefix, element, parameter } = props;

    const commandStack = useService("commandStack");
    const translate = useService("translate");
    const debounce = useService("debounceInput");

    const setValue = (value) => {
        commandStack.execute("element.updateModdleProperties", {
            element,
            moddleElement: parameter,
            properties: {
                condition: value,
            },
        });
    };

    const getValue = (parameter) => {
        return parameter.condition;
    };

    return TextFieldEntry({
        element: parameter,
        id: idPrefix + "-condition",
        label: translate("Condition"),
        getValue,
        setValue,
        debounce,
    });
}

function Priority(props) {
    const { idPrefix, element, parameter } = props;

    const commandStack = useService("commandStack");
    const translate = useService("translate");
    const debounce = useService("debounceInput");

    const setValue = (value) => {
        commandStack.execute("element.updateModdleProperties", {
            element,
            moddleElement: parameter,
            // priority: (typeof(value) === 'number') ? value : undefined
            properties: {
                priority: value,
            },
        });
    };

    const getValue = (parameter) => {
        return parameter.priority;
    };

    return NumberFieldEntry({
        element: parameter,
        id: idPrefix + "-priority",
        label: translate("Priority"),
        min: 0,
        getValue,
        setValue,
        debounce,
    });
}
